import React, { useState } from "react";

export const getCurrentValue = (value, field) => {
  let currentValue = field ? (value ? value[field] : null) : value;
  if (currentValue?.id) {
    currentValue = currentValue.id;
  }
  return currentValue;
};

export const handleSelectUpdate = (
  e,
  value,
  field,
  options,
  update,
  onUpdate
) => {
  let selectedValue = e.target.value;
  if (options[0].value?.id) {
    const selecteds = options.filter((o) => {
      return o.value.id === Number(selectedValue);
    });
    if (selecteds.length) {
      selectedValue = selecteds[0].value;
    }
  }
  if (selectedValue === "") {
    selectedValue = null;
  }
  if (!field) {
    update(selectedValue);
  } else {
    const newValue = { ...value };
    newValue[field] = selectedValue;
    update(newValue);
  }
  if (onUpdate) {
    onUpdate(selectedValue);
  }
};

export const Option = ({ item, className = "text-black" }) => (
  <option
    className={className}
    value={
      item.value !== undefined
        ? item.value.id
          ? item.value.id
          : item.value
        : item
    }
    disabled={item.disabled}
  >
    {item.label ? item.label : item}
  </option>
);

export default function SelectField({
  className = "",
  value,
  field,
  errors,
  Icon,
  options = [],
  placeholder = "Selecione",
  label,
  update,
  onUpdate,
  ...props
}) {
  const [isFocused, setIsFocused] = useState(false);

  let currentValue = getCurrentValue(value, field);

  return (
    <div className={`relative ${className}`}>
      {label && <label className="font-bold text-secondary">{label}</label>}
      <div
        className={`flex border-2 w-full h-12 ${
          isFocused ? "border-secondary" : "border-secondary/50"
        }`}
      >
        {Icon ? (
          <div className="flex items-center justify-center shrink-0 w-12 bg-white/20">
            <Icon
              className={`${
                isFocused ? "fill-secondary" : "fill-secondary/50"
              }`}
              width={16}
            />
          </div>
        ) : null}
        <select
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          className="border-none focus:outline-0 w-full h-full px-3 text-white bg-transparent mr-2.5"
          value={currentValue}
          onChange={(e) =>
            handleSelectUpdate(e, value, field, options, update, onUpdate)
          }
          {...props}
        >
          {[{ value: "", label: placeholder }, ...options].map((o, index) => (
            <Option key={"sfo" + index} item={o} />
          ))}
        </select>
      </div>
      {errors && errors[field] ? (
        <div className="absolute right-1.5 bottom-[-10px] px-2 bg-validation text-danger rounded-sm">
          {errors[field]}
        </div>
      ) : null}
    </div>
  );
}
